import React from 'react'
import { BrowserRouter, StaticRouter } from 'react-router-dom'

// When server rendering, we don't have a DOM and cannot use BrowserRouter, so we
// use StaticRouter when server rendering and then switch to BrowserRouter when we
// have a DOM (when we've mounted). This component abstracts those concerns.

export default class UniversalRouter extends React.Component {
  static defaultProps = {
    context: {},
  }

  state = {
    mounted: false,
  }

  componentDidMount() {
    this.setState({ mounted: true })
  }

  render() {
    const Router = this.state.mounted ? BrowserRouter : StaticRouter
    return <Router {...this.props} />
  }
}
